/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

import {
     DatabaseAgileFieldFromJSONTyped,
     DatabaseBasicFieldFromJSONTyped,
     DatabaseCalcFieldFromJSONTyped,
     DatabaseCategoryFieldFromJSONTyped,
     DatabaseChecklistFieldFromJSONTyped,
     DatabaseCombinedTextFieldFromJSONTyped,
     DatabaseCreatedByFieldFromJSONTyped,
     DatabaseCreatedDateFieldFromJSONTyped,
     DatabaseCurrencyFieldFromJSONTyped,
     DatabaseDateFieldFromJSONTyped,
     DatabaseEmailFieldFromJSONTyped,
     DatabaseFileFieldFromJSONTyped,
     DatabaseImageFieldFromJSONTyped,
     DatabaseImageSeriesFieldFromJSONTyped,
     DatabaseLinkFieldFromJSONTyped,
     DatabaseModifiedByFieldFromJSONTyped,
     DatabaseModifiedDateFieldFromJSONTyped,
     DatabaseNumberFieldFromJSONTyped,
     DatabaseOwnerFieldFromJSONTyped,
     DatabasePasswordFieldFromJSONTyped,
     DatabasePercentageFieldFromJSONTyped,
     DatabasePeriodFieldFromJSONTyped,
     DatabaseRatingFieldFromJSONTyped,
     DatabaseEntryStatisticsFieldFromJSONTyped,
     DatabaseTelnumberFieldFromJSONTyped,
     DatabaseTextFieldFromJSONTyped,
     DatabaseVideoFieldFromJSONTyped,
     DatabaseYesNoFieldFromJSONTyped
} from './';

/**
 * 
 * @export
 * @interface DatabaseField
 */
export interface DatabaseField {
    /**
     * 
     * @type {string}
     * @memberof DatabaseField
     */
    fieldType: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseField
     */
    readonly id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    displayInPreview?: boolean;
    /**
     * 
     * @type {DatabaseFieldPreviewOptions}
     * @memberof DatabaseField
     */
    displayPreviewOptions?: DatabaseFieldPreviewOptions;
    /**
     * 
     * @type {string}
     * @memberof DatabaseField
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseField
     */
    titlePhrase?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    showTitleAsPhrase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    hideTitle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    required?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    showInDetails?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    showInFilter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseField
     */
    showInSorter?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseField
     */
    fieldGroup?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseField
     */
    templateField?: string;
    /**
     * 
     * @type {Array<DatabaseFieldVisibilityRule>}
     * @memberof DatabaseField
     */
    visibilityRules?: Array<DatabaseFieldVisibilityRule>;
}

/**
 * Check if a given object implements the DatabaseField interface.
 */
export function instanceOfDatabaseField(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fieldType" in value;

    return isInstance;
}

export function DatabaseFieldFromJSON(json: any): DatabaseField {
    return DatabaseFieldFromJSONTyped(json, false);
}

export function DatabaseFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['fieldType'] === 'AGILE_FIELD') {
            return DatabaseAgileFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'BASIC_FIELD') {
            return DatabaseBasicFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CALC_FIELD') {
            return DatabaseCalcFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CATEGORY_FIELD') {
            return DatabaseCategoryFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CHECKLIST_FIELD') {
            return DatabaseChecklistFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'COMBINED_TEXT_FIELD') {
            return DatabaseCombinedTextFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CREATED_BY_FIELD') {
            return DatabaseCreatedByFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CREATED_DATE_FIELD') {
            return DatabaseCreatedDateFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'CURRENCY_FIELD') {
            return DatabaseCurrencyFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'DATE_FIELD') {
            return DatabaseDateFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'EMAIL_FIELD') {
            return DatabaseEmailFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'FILE_FIELD') {
            return DatabaseFileFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'IMAGE_FIELD') {
            return DatabaseImageFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'IMAGE_SERIES_FIELD') {
            return DatabaseImageSeriesFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'LINK_FIELD') {
            return DatabaseLinkFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'MODIFIED_BY_FIELD') {
            return DatabaseModifiedByFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'MODIFIED_DATE_FIELD') {
            return DatabaseModifiedDateFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'NUMBER_FIELD') {
            return DatabaseNumberFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'OWNER_FIELD') {
            return DatabaseOwnerFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'PASSWORD_FIELD') {
            return DatabasePasswordFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'PERCENTAGE_FIELD') {
            return DatabasePercentageFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'PERIOD_FIELD') {
            return DatabasePeriodFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'RATING_FIELD') {
            return DatabaseRatingFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'STATISTICS_FIELD') {
            return DatabaseEntryStatisticsFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'TELNUMBER_FIELD') {
            return DatabaseTelnumberFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'TEXT_FIELD') {
            return DatabaseTextFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'VIDEO_FIELD') {
            return DatabaseVideoFieldFromJSONTyped(json, true);
        }
        if (json['fieldType'] === 'YES_NO_FIELD') {
            return DatabaseYesNoFieldFromJSONTyped(json, true);
        }
    }
    return {
        
        'fieldType': json['fieldType'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'displayInPreview': !exists(json, 'displayInPreview') ? undefined : json['displayInPreview'],
        'displayPreviewOptions': !exists(json, 'displayPreviewOptions') ? undefined : DatabaseFieldPreviewOptionsFromJSON(json['displayPreviewOptions']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'titlePhrase': !exists(json, 'titlePhrase') ? undefined : json['titlePhrase'],
        'showTitleAsPhrase': !exists(json, 'showTitleAsPhrase') ? undefined : json['showTitleAsPhrase'],
        'hideTitle': !exists(json, 'hideTitle') ? undefined : json['hideTitle'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'required': !exists(json, 'required') ? undefined : json['required'],
        'showInDetails': !exists(json, 'showInDetails') ? undefined : json['showInDetails'],
        'showInFilter': !exists(json, 'showInFilter') ? undefined : json['showInFilter'],
        'showInSorter': !exists(json, 'showInSorter') ? undefined : json['showInSorter'],
        'fieldGroup': !exists(json, 'fieldGroup') ? undefined : json['fieldGroup'],
        'templateField': !exists(json, 'templateField') ? undefined : json['templateField'],
        'visibilityRules': !exists(json, 'visibilityRules') ? undefined : ((json['visibilityRules'] as Array<any>).map(DatabaseFieldVisibilityRuleFromJSON)),
    };
}

export function DatabaseFieldToJSON(value?: DatabaseField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldType': value.fieldType,
        'displayInPreview': value.displayInPreview,
        'displayPreviewOptions': DatabaseFieldPreviewOptionsToJSON(value.displayPreviewOptions),
        'name': value.name,
        'titlePhrase': value.titlePhrase,
        'showTitleAsPhrase': value.showTitleAsPhrase,
        'hideTitle': value.hideTitle,
        'active': value.active,
        'required': value.required,
        'showInDetails': value.showInDetails,
        'showInFilter': value.showInFilter,
        'showInSorter': value.showInSorter,
        'fieldGroup': value.fieldGroup,
        'templateField': value.templateField,
        'visibilityRules': value.visibilityRules === undefined ? undefined : ((value.visibilityRules as Array<any>).map(DatabaseFieldVisibilityRuleToJSON)),
    };
}

